/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompletedTraining } from './CompletedTraining';
import {
    CompletedTrainingFromJSON,
    CompletedTrainingFromJSONTyped,
    CompletedTrainingToJSON,
    CompletedTrainingToJSONTyped,
} from './CompletedTraining';

/**
 * 
 * @export
 * @interface UpdateHistoryEntry
 */
export interface UpdateHistoryEntry {
    /**
     * 
     * @type {string}
     * @memberof UpdateHistoryEntry
     */
    entryId: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateHistoryEntry
     */
    completionTime: number;
    /**
     * 
     * @type {CompletedTraining}
     * @memberof UpdateHistoryEntry
     */
    trainingEntry: CompletedTraining;
}

/**
 * Check if a given object implements the UpdateHistoryEntry interface.
 */
export function instanceOfUpdateHistoryEntry(value: object): value is UpdateHistoryEntry {
    if (!('entryId' in value) || value['entryId'] === undefined) return false;
    if (!('completionTime' in value) || value['completionTime'] === undefined) return false;
    if (!('trainingEntry' in value) || value['trainingEntry'] === undefined) return false;
    return true;
}

export function UpdateHistoryEntryFromJSON(json: any): UpdateHistoryEntry {
    return UpdateHistoryEntryFromJSONTyped(json, false);
}

export function UpdateHistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateHistoryEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'entryId': json['entryId'],
        'completionTime': json['completionTime'],
        'trainingEntry': CompletedTrainingFromJSON(json['trainingEntry']),
    };
}

export function UpdateHistoryEntryToJSON(json: any): UpdateHistoryEntry {
    return UpdateHistoryEntryToJSONTyped(json, false);
}

export function UpdateHistoryEntryToJSONTyped(value?: UpdateHistoryEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entryId': value['entryId'],
        'completionTime': value['completionTime'],
        'trainingEntry': CompletedTrainingToJSON(value['trainingEntry']),
    };
}

